import { type RefAttributes, useImperativeHandle, useMemo, useState } from 'react';
import { useFetcher } from 'react-router';
import {
  EditPaymentMethodModal,
  type PartialCardPaymentInstrument,
  type PaymentMethodModalLabels,
} from './payment-method-modal.tsx';

export type EditPaymentDetailsModalHandle = {
  // allow parent to toggle modal, while maintaining modal state internally
  toggleModal: () => void;
};

export type EditPaymentDetailsModalProps = RefAttributes<EditPaymentDetailsModalHandle> & {
  paymentIdentityId: string | null;
  instrumentId?: string;
  paymentInstruments: {
    __typename: string;
    data?: PartialCardPaymentInstrument[];
  };
  onCloseHandler: () => void;
  labels?: PaymentMethodModalLabels;
};

export const EditPaymentDetailsModal = ({
  ref,
  paymentIdentityId,
  paymentInstruments,
  instrumentId,
  onCloseHandler,
  labels,
}: EditPaymentDetailsModalProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const selectedPaymentInstrument = useMemo(() => {
    return paymentInstruments.data?.find(instrument => instrument.id === instrumentId);
  }, [instrumentId, paymentInstruments.data]);

  const fetcher = useFetcher();

  useImperativeHandle(ref, () => ({
    toggleModal: () => {
      setIsModalOpen(!isModalOpen);
    },
  }));

  return (
    <EditPaymentMethodModal
      {...{
        isModalOpen,
        fetcher,
        paymentIdentityId,
        selectedPaymentInstrument,
        labels,
      }}
      onCloseHandler={() => {
        setIsModalOpen(false);
        onCloseHandler();
      }}
    />
  );
};
